import * as React from 'react';
import * as Yup from 'yup';

import { useFormik } from 'formik';

import InputAdornment from '@mui/material/InputAdornment';
// icons
import MailOutlineIcon from '@mui/icons-material/MailOutline';

import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Link from '@mui/material/Link';
import Box from '@mui/material/Box';
import Alert from '@mui/material/Alert';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { createTheme, ThemeProvider } from '@mui/material/styles';
//import { useSnackbar } from 'notistack';

import useAuth from '../../hooks/useAuth';
import useIsMountedRef from '../../hooks/useIsMountedRef';
// utils
import axios from "../../utils/axios";
// 
import { useTranslation } from 'react-i18next';


const theme = createTheme();

export default function RequestPasswordForm() {
  const isMountedRef = useIsMountedRef();
  const { t } = useTranslation();
  const [alertError, setAlertError] = React.useState('');
  const [alertMessage, setAlertMessage] = React.useState('');

  const resetAlerts = () => {
    setAlertError('');
    setAlertMessage('');
  }

  const EmailSchema = Yup.object().shape({
    email: Yup.string()
      .email('Email non valida.')
      .required('Email obbligatoria.'),
  });

  const formik = useFormik({
    initialValues: {
      email: '',
    },
    validationSchema: EmailSchema,
    onSubmit: async (values, { setErrors, setSubmitting, resetForm }) => {
      try {
        resetAlerts();
        const response = await axios.post(`/auth/password/request`, { email: values.email });

        if (response.data.success) {
          setAlertMessage(t(response.data.message));
        }

        resetForm({
          values: {
            email: ''
          },
        });
      } catch (error) {
        console.error(error);

        const errorMessage = Object.values(error.data)[0][0]
        setErrors({ afterSubmit: errorMessage });

        if (error.status === 422) {
          setErrors({ afterSubmit: errorMessage });
          resetForm();
        } else {
          setAlertError(t(error.data.message));
        }

        if (isMountedRef.current) {
          resetForm({
            values: {
              email: ''
            },
          });

          setSubmitting(false);
        }
      }
    }
  });

  const { errors, touched, values, isSubmitting, handleSubmit, getFieldProps } = formik;

  return (

    <Container component="div" sx={{ m: 0, p: 0, maxWidth: "unset !important" }}>
      <CssBaseline />
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          p: 0,
          m: 0,
        }}
      >

        <Typography component="h1" variant="h4" sx={{ color: '#004990', fontWeight: 'bold' }}>
          {t("authentication.password_reset.request_title")}
        </Typography>

        <form onSubmit={formik.handleSubmit} style={{ minWidth: "70%" }}>
          {alertError && <Alert severity="error" sx={{ mt: 2, mb: 1 }}>{alertError}</Alert>}
          {alertMessage && <Alert severity="success" sx={{ mt: 2, mb: 1 }}>{alertMessage}</Alert>}

          <TextField
            margin="normal"
            variant="outlined"

            fullWidth
            id="email"
            placeholder={t("authentication.fields.email")}
            name="email"
            autoComplete="email"
            autoFocus
            value={formik.values.email}
            onChange={formik.handleChange}
            error={formik.touched.email && Boolean(formik.errors.email)}
            helperText={formik.touched.email && formik.errors.email}
            sx={styles.inputText}

            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <MailOutlineIcon sx={{ color: "#6369E9" }} />
                </InputAdornment>
              ),
            }}
          />

          <Stack direction="column" justifyContent="center" alignItems="center" spacing={3} sx={{ mt: 4, textAlign: "center" }}>
            <Button
              type="submit"
              variant="contained"
              sx={{ p: '8px 50px', backgroundColor: '#2CA4DE' }}
            >
              {t("authentication.password_reset.request_submit")}
            </Button>
            <Link href="/auth/login" variant="body2">
              {t("authentication.login_link")}
            </Link>
          </Stack>
        </form>
      </Box>

    </Container>
  );
}

const styles = {
  inputText: {
    // backgroundColor: '#EEF2F6',
    border: '0px solid',
    // p: '1rem',
    borderRadius: '10px',
  },
}